import { notifications } from '@mantine/notifications';
import {
  getCashAccountsKey,
  useCreateCashAccount,
} from 'api-hooks/cash-account';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { NavigationProps } from 'types';

import CashAccountForm from './components/form';

export type CashAccountCreateParams = null;

export default function CashAccountCreate(
  props: NavigationProps<NavigationRoutes.CashAccountsCreate>,
) {
  const { back, navigate } = useNavigation();

  const createMutation = useCreateCashAccount();
  const permission = useGetCrudPermission('cash-accounts');

  return (
    <CashAccountForm
      onSubmit={async (input) => {
        const result = await createMutation.mutateAsync(input);
        queryClient.refetchQueries(getCashAccountsKey());
        const prevPath = PreviousNavigation.get();
        if (prevPath) {
          PreviousNavigation.remove();
          back();
        } else if (permission.view) {
          navigate(NavigationRoutes.CashAccountsView, {
            id: result.data?.id,
          });
        }

        notifications.show({ message: result?.message, color: 'green' });

        return result.data;
      }}
      saveMutation={createMutation}
    />
  );
}
